import {EmptyGuid} from "../utils/globalVariables";
import {IEntity} from "./IEntity";

export interface IPostHolderAddRequest extends IEntity {
    PostHolderName: string;
    PostHolderRole: string;
}

export const PostHolderAddRequest: IPostHolderAddRequest = {
    Id: EmptyGuid,
    PostHolderName: '',
    PostHolderRole: ''
}